/**
 * Client-side import helpers for the Library owner tools. PDF extraction uses
 * pdfjs-dist (lazy-loaded so it doesn't bloat the main bundle).
 */

export async function readMarkdownFile(file: File): Promise<string> {
  const text = await file.text();
  return text.replace(/\r\n/g, "\n");
}

/** First markdown H1 as a title, else the fallback. */
export function titleFromMarkdown(md: string, fallback: string): string {
  const m = md.match(/^#\s+(.+)$/m);
  return m ? m[1].trim() : fallback;
}

export async function extractPdfText(file: File): Promise<string> {
  const pdfjs = await import("pdfjs-dist");
  const worker = await import("pdfjs-dist/build/pdf.worker.min.mjs?url");
  pdfjs.GlobalWorkerOptions.workerSrc = worker.default;

  const data = await file.arrayBuffer();
  const doc = await pdfjs.getDocument({ data }).promise;
  const parts: string[] = [];
  for (let i = 1; i <= doc.numPages; i++) {
    const page = await doc.getPage(i);
    const content = await page.getTextContent();
    const line = content.items
      .map((it) => ("str" in it ? (it as { str: string }).str : ""))
      .join(" ")
      .trim();
    if (line) parts.push(line);
  }
  return parts.join("\n\n").replace(/\n{3,}/g, "\n\n").trim();
}

export function fileBaseName(name: string): string {
  return name.replace(/\.[^.]+$/, "");
}
